(function () {
  var BUY = '#A6540D';
  var BUY_RGB = /166, 84, 13/;
  var OLD = /rgb\(160, 82, 45\)|#a0522d/gi;
  function num(el) {
    if (!el) return NaN;
    var t = el.textContent.replace(/[^0-9,.]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    return parseFloat(t);
  }
  function buyButtons() {
    document.querySelectorAll('.es-popup-button, .es-cta-btn, .es-button, .es-sticky-btn').forEach(function (b) {
      if (!BUY_RGB.test(getComputedStyle(b).backgroundColor) || b.dataset.msBuy !== '1') {
        b.style.setProperty('background', BUY, 'important');
        b.style.setProperty('border-color', BUY, 'important');
        b.dataset.msBuy = '1';
      }
    });
    document.querySelectorAll('[class*="es-"][style], [class*="es-"] [style]').forEach(function (e) {
      var s = e.getAttribute('style');
      OLD.lastIndex = 0;
      if (s && OLD.test(s)) { OLD.lastIndex = 0; e.setAttribute('style', s.replace(OLD, BUY)); }
      OLD.lastIndex = 0;
    });
  }
  function run() {
    buyButtons();
    document.querySelectorAll('.price--on-sale').forEach(function (price) {
      var reg = num(price.querySelector('.price__sale .price-item--regular'));
      var sale = num(price.querySelector('.price__sale .price-item--sale'));
      if (!(reg > sale)) return;
      var label = '-' + Math.round((1 - sale / reg) * 100) + '%';
      var scope = price.closest('.card-wrapper, .product__info-container, .product') || price.parentNode;
      scope.querySelectorAll('.badge').forEach(function (b) {
        if (b.dataset.msDone === label) return;
        if (/akcij|sale|popust|%/i.test(b.textContent)) { b.textContent = label; b.dataset.msDone = label; }
      });
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();
